/**
 * 曝光统计组件
 */
import React, { useCallback, useEffect } from 'react';
import Grounds from '../index';
import 'intersection-observer';
export class Expose {
    constructor() {
        this.doExpose = (staList, index) => {
            Grounds.expose(JSON.stringify(staList[index]));
        };
        this.Container = ({ children, listStyle = '', staList, viewPort }) => {
            const wrapObserve = (item, index) => {
                const id = item.id || index;
                if (this.exposed.has(id))
                    return;
                const OB = new IntersectionObserver((entries) => {
                    if (entries[0].intersectionRatio <= 0)
                        return;
                    if (this.exposed.has(id)) {
                        if (this.OBs[id]) {
                            this.OBs[id].disconnect();
                            delete this.OBs[id];
                        }
                        return;
                    }
                    this.exposed.add(id);
                    this.doExpose(staList, index);
                }, {
                    root: viewPort !== undefined ? viewPort : listNode
                });
                OB.observe(item);
                this.OBs[id] = OB;
            };
            useEffect(() => {
                return () => Object.values(this.OBs).forEach((item) => item.disconnect());
            }, []);
            let listNode;
            const listRef = useCallback((node) => {
                if (!node)
                    return;
                listNode = node;
                Array.from(node.childNodes).forEach((item, index) => wrapObserve(item, index));
            }, [children, staList]);
            return (React.createElement("div", { className: listStyle, ref: listRef }, children));
        };
        this.exposed = new Set();
        this.OBs = {};
    }
}
